// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__96FKK","backwards":"navigation_backwards__2trMJ","forwards":"navigation_forwards__40f1f","sticky":"navigation_sticky__lecCz"};